import { LEAD_STATUS } from '@/constants';
import * as vars from '@/styles/vars.module.scss';
import styles from './styles.module.scss';

/**
 * @param {object} props
 * @param {string|undefined} props.value
 * @param {string} props.valueFormatted
 */
const LeadStatusRenderer = ({ value, valueFormatted }) => {
  if (value === undefined) {
    return <div>{valueFormatted}</div>;
  }

  const getColor = status => {
    switch (status) {
      case LEAD_STATUS.lead:
        return vars['color-status-active'];

      case LEAD_STATUS.inactive:
        return vars['color-status-default'];

      case LEAD_STATUS.assigned:
        return vars['color-status-progress'];

      case LEAD_STATUS.appointment:
        return vars['color-status-overridden'];

      case LEAD_STATUS.win:
        return vars['color-status-win'];

      case LEAD_STATUS.duplicate:
      default:
        return vars['color-status-fault'];
    }
  };

  return (
    <div
      data-cy="cell-renderer"
      className={styles.statusContainer}
      style={{ borderColor: getColor(valueFormatted) }}
    >
      {valueFormatted}
    </div>
  );
};

export default LeadStatusRenderer;
